module.exports = __webpack_public_path__ + "static/img/aepic-1.99e9b2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-1.jpg
// module id = rPwP
// module chunks = 52